export default "__VITE_ASSET__CqbApUun__"